import Loadable from 'react-loadable';
export var LoadableSimpleEmoji = Loadable({
  loader: function loader() {
    return import( /* webpackChunkName: "@atlaskit-internal_simpleEmoji" */'./SimpleEmoji').then(function (component) {
      return component.SimpleEmoji;
    });
  },
  loading: function loading() {
    return null;
  }
});
export var LoadableSimpleEmojiPlaceholder = Loadable({
  loader: function loader() {
    return import( /* webpackChunkName: "@atlaskit-internal_simpleEmoji" */'./SimpleEmoji').then(function (component) {
      return component.SimpleEmojiPlaceholder;
    });
  },
  loading: function loading() {
    return null;
  }
});